import { useCallback, useEffect, useState } from 'react';
import { useGetConfigurationBySlugMutation, useSubmitDprRequestMutation } from '../../__generated__/chirp/com/hubspot/privacy/center/rpc/DprPublicRpc.hooks';
import { captureException } from '../utils/captureException';
import { setFavicon, setTabTitle } from '../utils/brandingUtils';
import { genericSubmitErrorAlert, rateLimitErrorAlert } from '../utils/alerts';
import useLocaleContext from './useLocaleContext';
import { getChirpErrorType } from '../utils/getApolloErrorStatusCode';
function useDataPrivacyConfig(slug) {
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const {
    locale
  } = useLocaleContext();
  const [fetchConfig, {
    data: dataPrivacyConfig,
    loading: loadingConfig,
    error: errorFetchingConfig
  }] = useGetConfigurationBySlugMutation({
    onError: err => {
      captureException(err, ['Error fetching data privacy config']);
    },
    onCompleted: data => {
      var _data$result;
      const branding = data === null || data === void 0 || (_data$result = data.result) === null || _data$result === void 0 ? void 0 : _data$result.branding;
      setTabTitle(branding === null || branding === void 0 ? void 0 : branding.companyName);
      setFavicon(branding === null || branding === void 0 ? void 0 : branding.faviconUrl);
    }
  });
  useEffect(() => {
    void fetchConfig({
      variables: {
        slug
      }
    });
  }, [fetchConfig, slug]);
  const [submitDprRequest, {
    loading: loadingSubmit
  }] = useSubmitDprRequestMutation({
    onCompleted: () => {
      setRequestSubmitted(true);
    },
    onError: err => {
      const errorType = getChirpErrorType(err);
      if (errorType === 'RATE_LIMIT_EXCEEDED') {
        rateLimitErrorAlert(locale);
      } else {
        genericSubmitErrorAlert(locale);
      }
      captureException(err, ['Error submitting data privacy request']);
    }
  });
  const submitRequest = useCallback(payload => {
    void submitDprRequest({
      variables: Object.assign({
        slug
      }, payload)
    });
  }, [slug, submitDprRequest]);
  return {
    dataPrivacyConfig,
    errorFetchingConfig,
    loading: loadingConfig || loadingSubmit,
    requestSubmitted,
    submitRequest
  };
}
export default useDataPrivacyConfig;